import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { BcContestResult, IBcContestApplication } from '../../../models/BcContest';
import { AppService } from '../../../services/app.service';
import { BcContestService } from '../../../services/bc-contest.service';
import { bcState } from '../shared';

@Component({
    templateUrl: './bc-contest-application-edit.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestApplicationEditComponent {
    constructor(
        private app: AppService,
        private service: BcContestService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set data(value: IBcContestApplication) {
        this._application = value;
        this.result = value.Result;
    }

    result: BcContestResult;
    isSaving: boolean;

    readonly availableResults: BcContestResult[] = ['In', 'Out', 'NotApplicable'];

    readonly resultDisplayFn = (value: BcContestResult) => value ? this.app.translate(`bcContest_result${value}`) : '';

    get application() {
        return this._application;
    }

    private _application: IBcContestApplication;

    save() {
        this.isSaving = true;

        setTimeout(() => {
            this.service.updateApplication(this.application.Id, {
                result: this.result
            }).pipe(finalize(() => {
                this.isSaving = false;
            })).subscribe(data => {
                this.application.Result = this.result;
                this.activeModal.close();

                bcState.updateApplication(this.application);
            });
        }, 500);
    }

    close() {
        this.activeModal.dismiss();
    }
}
